<template>
  <!-- 显示学员练习答题详情-->
  <a-modal
    width="750px"
    :title="exercisesName"
    :mask-closable="false"
    :visible="errorExercisesVisible"
    :userId="userId"
    @cancel="onCancelShowErrorExercises"
    :footer="null"
    :destroyOnClose="true"
    class="show-login-list show-exercises-times"
  >
    <div class="level-area">
      <div>
        <el-pagination
          small
          :pageSize="100"
          layout="prev, pager, next"
          :background="true"
          :total="pageCount"
          @current-change="paginationChange"
          v-if="pageCount"
        >
        </el-pagination>
      </div>
      <div>
        <span>考试等级：</span>
        <a-cascader
          style="width: 250px; margin: 0"
          :options="selectOptions"
          @change="changeSelect"
          :fieldNames="{ label: 'name', value: 'id', children: 'children' }"
          placeholder="请选择考试等级"
        />
      </div>
    </div>
    <div v-if="errorExercisesDetailLoading" class="spin"><a-spin /></div>
    <el-empty
      description="暂无数据"
      :imageSize="100"
      v-if="errorExercisesDetailData.length == 0"
    ></el-empty>
    <div class="question-bank" :class="pageCount ? '' : 'border-none'">
      <div
        class="qbox"
        v-for="(item, index) in errorExercisesDetailData"
        :key="index"
      >
        <!-- 题干 -->
        <div class="question-header">
          <span class="type">{{ getType(item.type) }}</span>
          <span class="stems">{{ ++index }}. {{ item.title }}</span>
        </div>
        <div class="question-body">
          <!-- 选项 -->
          <div
            class="answer-box"
            v-for="(anitem, anindex) in item.questionAnswerList"
            :class="switchAnswer(anitem.answerTitle, item.rightkey)"
            :key="anindex"
          >
            <div style="display: flex">
              <div style="width: 20px">{{ anitem.answerTitle }}.</div>
              <div>{{ anitem.content }}</div>
            </div>
            <div class="icon">
              <a-icon
                :type="
                  switchAnswer(anitem.answerTitle, item.rightkey) == 'red'
                    ? 'close-circle'
                    : 'check-circle'
                "
              />
            </div>
          </div>

          <!-- 答案 -->
          <div class="answers">
            <div class="answer-box">
              <div class="right">
                正确答案：<span class="green">{{ item.rightkey }}</span>
              </div>
              <div>已选答案：{{ item.myAnswer }}</div>
            </div>
            <!-- 知识点解析 -->
            <div class="knowledges" v-if="item.knowledges != undefined">
              <span class="jiexi">解析：</span>
              <span
                class="em"
                v-for="(knitem, knindex) in item.knowledges"
                :key="knindex"
                >{{ knitem }}</span
              >
            </div>
          </div>
        </div>
        <a-divider
          type="horizontal"
          :dashed="true"
          v-if="index != errorExercisesDetailData.length"
        />
      </div>
    </div>
  </a-modal>
</template>

<script>
export default {
  props: ["userId", "userName", "userGrade", "errorExercisesVisible"],
  data() {
    return {
      pageCount: 0,
      currentPage: 1,
      selectOptions: [],
      questionsLevel: [],
      exercisesName: "",
      errorExercisesDetailData: [],
      errorExercisesDetailLoading: false,
    };
  },
  watch: {
    errorExercisesVisible() {
      if (this.errorExercisesVisible) {
        this.exercisesName =
          this.userName + "(班级: " + this.userGrade + ")  练习错题记录";
        this.getpaperCategory();
      }
    },
  },
  mounted() {},
  methods: {
    paginationChange(curr) {
      this.currentPage = curr;
      this.showErrorExercisesDetail();
    },
    async getpaperCategory() {
      let result = await this.$http.post("/paperCategory/types", {});
      if (result.data.status === 1) {
        this.selectOptions = result.data.data;
      }
    },
    changeSelect(value, selectedOptions) {
      this.questionsLevel = value;
      this.currentPage = 1;
      this.showErrorExercisesDetail();
    },
    onCancelShowErrorExercises() {
      this.pageCount = 0;
      this.exercisesName = "";
      this.currentPage = 1;
      this.errorExercisesDetailData = [];
      this.$parent.hiddenModelType("errorExercises");
    },
    async showErrorExercisesDetail() {
      this.errorExercisesDetailLoading = true;
      let result = await this.$http.post("/promoter/showErrorDetail", {
        questions_level: this.questionsLevel,
        user_id: this.userId,
        page: this.currentPage,
        type: "exercises",
      });
      if (result.data.status === 1) {
        this.errorExercisesDetailLoading = false;
        this.pageCount = result.data.data.count;
        this.errorExercisesDetailData = result.data.data.question_list;
      } else {
        this.errorExercisesDetailLoading = false;
      }
    },
    switchAnswer(answerTitle, rightkey) {
      let rightkeyArr = rightkey.split(",");
      return rightkeyArr.includes(answerTitle) ? "green" : "red";
    },
    getType(type) {
      let name = "";
      if (type == 1) {
        name = "单选题";
      } else if (type == 2) {
        name = "多选题";
      } else if (type == 3) {
        name = "判断题";
      } else {
        name = "简答题";
      }

      return name;
    },
  },
};
</script>

<style>
.show-login-list .ant-modal-content .ant-modal-header {
  padding: 16px 24px;
  color: rgba(0, 0, 0, 0.65);
  background: #fff;
  border-bottom: 1px solid #e8e8e8;
  border-radius: 4px 4px 0 0;
  height: auto;
}
.show-login-list .ant-modal-content .ant-modal-header .ant-modal-title {
  margin: 0 !important;
}

.show-exercises-times {
  top: 2px !important;
  padding-bottom: 0;
}

.show-exercises-times .ant-modal-body {
  height: calc(100vh - 60px);
  padding-top: 15px;
  /* overflow-y: auto; */
}

.show-exercises-times .ant-modal-body .spin {
  position: absolute;
  left: calc(375px - 12px);
  top: 200px;
}

.level-area .el-pagination {
  padding-left: 0;
}
.level-area .el-pagination .btn-prev {
  margin-left: 0 !important;
}

.level-area .el-pagination.is-background .btn-next,
.el-pagination.is-background .btn-prev,
.el-pagination.is-background .el-pager li {
  background: #ffffff;
}
</style>
<style lang="scss" scoped>
.level-area {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 15px;
}
.spin {
  text-align: center;
}
.question-bank {
  overflow: auto;
  border-top: 1px solid #e8e8e8;
  max-height: calc(100vh - 132px);
  padding-right: 10px;
  overflow-y: auto;
}
.border-none {
  border: none;
}
.qbox {
  padding-bottom: 0px;

  .question-header {
    width: 100%;
    margin-bottom: 15px;

    .type {
      background: #1890ff;
      padding: 1px 5px;
      display: inline-block;
      border-radius: 2px;
      color: #ffffff;
      margin-right: 5px;
    }

    .stems {
      font-size: 16px;
      font-weight: 500;
    }
  }

  .question-body {
    .answer-box {
      display: flex;
      justify-content: space-between;
      margin-bottom: 10px;
      font-size: 14px;

      .icon {
        padding-left: 3px;
      }

      .right {
        width: 200px;
        white-space: nowrap;
        overflow: hidden;
      }
    }

    .answers {
      border: 1px solid #eff6ff;
      background: #eff6ff;
      border-radius: 5px;
      margin: 10px auto;
      display: block;
      padding: 15px;
    }

    .red {
      color: red;
    }
    .green {
      color: green;
    }

    .knowledges {
      margin-top: 20px;

      span {
        display: block;
        margin-bottom: 5px;
      }
      .jiexi {
        font-weight: 500;
      }

      .em {
        text-indent: 1em;
      }
    }
  }
}
</style>